export const get_status = (status) => {
    const state = {
        SOLD: "Продано",
        AVAILABLE: "Свободно",
        EXECUTION: "Со скидкой",
        BOOKED: "Забронировано"
    }
    return state[status]
}
